export default __webpack_public_path__ + "static/media/sc2.108c1da0.png";